import { ExecutionData } from '@store/types';
import { apiClient, NodeTrace } from '@store/index';

type getExecutionsInput = {
  service_id: string;
  startDate: string;
  endDate: string;
};

export const getExecutions = async ({ queryKey }: any): Promise<ExecutionData[]> => {
  const inputs = queryKey?.[1] as getExecutionsInput;

  const { service_id, startDate, endDate } = inputs;

  const response = await apiClient.get(`/${service_id}/reporting?startDate=${startDate}&endDate=${endDate}`);
  return response.data;
};

type getNodeExecutionsInput = {
  service_id: string;
  run_id: string;
};

export const getNodeExecutions = async ({ queryKey }: any): Promise<NodeTrace[]> => {
  const inputs = queryKey?.[1] as getNodeExecutionsInput;

  const { service_id, run_id } = inputs;

  const response = await apiClient.get(`/${service_id}/reporting/${run_id}`);
  return response.data;
};
